export const validateAgreementForm = formState => {
  let errMessage = null

  if (!formState.name) {
    errMessage = 'Please provide a NAME for the agreement.'
  } else if (!formState.period) {
    errMessage = 'Please mark PERIOD for the agreement.'
  } else if (formState.scopes.filter(s => !s.name).length) {
    errMessage = 'Please provide a NAME for each agreement SCOPE.'
  }

  return errMessage
}
